const [ w, d, l ] = [ window, document, location ]

//バリ取り男塾LP
const baritori_init = () => {

  //mainvisual タイトルにクラス付与
  Promise.all([ w.load['baritori'] ]).then( () => {
    $('.baritori-mainvisual__title').addClass('is-active');
  });

  // ページトップリンクをスクロール量で表示するサンプル
  $.scrollspy({
    trigger:200,
    onBefore(/* pos */) {
      $('.baritori-footer-fixNav').addClass('hidden-xsmall'),
      $('.baritori-pagetop__wrap').addClass('visible-xsmall');
    },
    onAfter() {
      $('.baritori-footer-fixNav').removeClass('hidden-xsmall'),
      $('.baritori-pagetop__wrap').removeClass('visible-xsmall');
    }
  });
}

export default function SERVICE() {

  //バリ取り男塾LP
  if( /article=2/.test(l.search)) $( baritori_init );

}